import React from 'react';

const StatesContext = React.createContext();


export default StatesContext;